<template>
  <div class="ma-5">
    <titleAgency />
    <v-tabs
      v-model="activeTab"
      @change="changeTab()"
      style="margin-top: -48px;"
      color="#2BA197"
      background-color="titlebackground"
    >
    <v-tabs-slider class="ml-0" color="#2BA197"></v-tabs-slider>
      <v-tab style="font-weight: 700;font-size: 16px;letter-spacing: 1px;">อนุมัติคำร้อง</v-tab>
      <v-tab style="font-weight: 700;font-size: 16px;letter-spacing: 1px;">รับทราบคำร้อง</v-tab>
    </v-tabs>
    <filterAgency :mode="page" v-if="render"/>
    <tableAgency :mode="page" v-if="render"/>
  </div>
</template>

<script>
import { EventBus } from '@/EventBus'
import titleAgency from '@/components/_manageapprove/_overview/title.vue'
import filterAgency from '@/components/_manageapprove/_overview/filter.vue'
import tableAgency from '@/components/_manageapprove/_overview/table.vue'
export default {
  components: {
    titleAgency, filterAgency, tableAgency
  },
  data () {
    return {
      activeTab: 0,
      page: 'approve',
      render: true
    }
  },
  methods: {
    changeTab (item) {
      this.forceRerender()
    },
    forceRerender () {
      if (this.activeTab === 0) {
        this.page = 'approve'
        // localStorage.setItem('manageapproveRole', 'Admin')
        EventBus.$emit('updateNavbarRole', localStorage.manageapproveRole, 0)
      } else if (this.activeTab === 1) {
        this.page = 'acknowledge'
        localStorage.setItem('manageapproveRole', 'Leader')
        EventBus.$emit('updateNavbarRole', 'Leader', 1)
      }
      this.render = false
      this.$nextTick(() => {
        this.render = true
      })
    }
  }
}
</script>

<style scoped>
.v-tab {
  font-family: 'Sarabun', sans-serif !important;
  font-weight: "600";
  font-size: 1.2rem;
}
</style>
